export default __webpack_public_path__ + "static/mmichelfelder-bbd3bbbcaf8c22e127a4dc4561a079eb.png";